var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mySubPage',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('myNav',[_vm._v("信誉值流动历史["+_vm._s(_vm.org_cname)+"]")])],1),_vm._v(" "),_c('div',{staticClass:"relative fillh"},[(_vm.org_id != '')?_c('myOrgCrSn',{attrs:{"org_id":_vm.org_id,"url":"org-cr-sn/list-by-org"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c61418b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/org/shop/crsn.vue
// module id = null
// module chunks = 